import { useEffect, useState } from 'react';
import type {
  AccountModel,
  GiayBaoNo,
  HanThanhToan,
  KhachHang,
  NganHang,
  QuyenChungTu,
  TaiKhoanNganHang
} from '@/types/schemas';

export interface GiayBaoNoSearchFieldState {
  loaiChungTu: string;
  bank: TaiKhoanNganHang | null;
  account: AccountModel | null;
  quyenChungTu: QuyenChungTu | null;
  soChungTu: string;
  loai_hd: string;
  hanTT: HanThanhToan | null;
  donViNhanTien: KhachHang | null;
  nganHangNhanTien: NganHang | null;
}

export interface GiayBaoNoSearchFieldActions {
  setLoaiChungTu: (value: string) => void;
  setBank: (value: TaiKhoanNganHang | null) => void;
  setAccount: (value: AccountModel | null) => void;
  setQuyenChungTu: (value: QuyenChungTu | null) => void;
  setSoChungTu: (value: string) => void;
  setNhomLoaiHD: (value: string) => void;
  setHanTT: (value: HanThanhToan | null) => void;
  setDonViNhanTien: (value: KhachHang | null) => void;
  setNganHangNhanTien: (value: NganHang | null) => void;
}

export const useSearchFieldStates = (initialData?: Partial<GiayBaoNo> | null) => {
  const [states, setState] = useState({
    loaiChungTu: initialData?.ma_ngv || '1',
    bank: initialData?.tknh_data || (null as TaiKhoanNganHang | null),
    account: initialData?.tk_data || (null as AccountModel | null),
    quyenChungTu: initialData?.ma_nk_data || (null as QuyenChungTu | null),
    soChungTu: initialData?.so_ct || '',
    loai_hd: initialData?.loai_hd || '1',

    hanTT: initialData?.ma_tt_data || (null as HanThanhToan | null),

    donViNhanTien: initialData?.ma_kh0_data || (null as KhachHang | null),
    nganHangNhanTien: initialData?.ma_ngan_hang_data || (null as NganHang | null)
  } satisfies GiayBaoNoSearchFieldState);

  useEffect(() => {
    if (initialData) {
      setState(prev => ({
        ...prev,
        loaiChungTu: initialData?.ma_ngv || prev.loaiChungTu,
        bank: initialData?.tknh_data || prev.bank,
        account: initialData?.tk_data || prev.account,
        quyenChungTu: initialData?.ma_nk_data || prev.quyenChungTu,
        soChungTu: initialData?.so_ct || prev.soChungTu,
        loai_hd: initialData?.loai_hd || prev.loai_hd,
        hanTT: initialData?.ma_tt_data || prev.hanTT,
        donViNhanTien: initialData?.ma_kh0_data || prev.donViNhanTien,
        nganHangNhanTien: initialData?.ma_ngan_hang_data || prev.nganHangNhanTien
      }));
    }
  }, [
    initialData?.ma_ngv,
    initialData?.tknh_data,
    initialData?.tk_data,
    initialData?.ma_nk_data,
    initialData?.so_ct,
    initialData?.loai_hd,
    initialData?.ma_tt_data,
    initialData?.ma_kh0_data,
    initialData?.ma_ngan_hang_data
  ]);

  const actions = {
    setLoaiChungTu: (value: string) => setState(prev => ({ ...prev, loaiChungTu: value })),
    setBank: (value: TaiKhoanNganHang | null) => setState(prev => ({ ...prev, bank: value })),
    setAccount: (value: AccountModel | null) => setState(prev => ({ ...prev, account: value })),
    setQuyenChungTu: (value: QuyenChungTu | null) => setState(prev => ({ ...prev, quyenChungTu: value })),
    setSoChungTu: (value: string) => setState(prev => ({ ...prev, soChungTu: value })),
    setNhomLoaiHD: (value: string) => setState(prev => ({ ...prev, loai_hd: value })),

    setHanTT: (value: HanThanhToan | null) => setState(prev => ({ ...prev, hanTT: value })),

    setDonViNhanTien: (value: KhachHang | null) => setState(prev => ({ ...prev, donViNhanTien: value })),
    setNganHangNhanTien: (value: NganHang | null) => setState(prev => ({ ...prev, nganHangNhanTien: value }))
  } satisfies GiayBaoNoSearchFieldActions;

  return {
    state: states,
    actions
  };
};
